// Shipping, delivery and returns copy plus the FAQ, shared by the React pages
// (through src/lib/shipping.ts and src/pages/FAQ.tsx) and the prerendered
// bodies of /faq, /shipping and /returns, so crawlers read the same terms the
// pages show. Every fact is the fulfilling store's own policy
// (furnifindusa.com/policies/shipping-policy and /refund-policy).
//
// The two numbers are also literals in src/lib/shipping.ts; prerender-og
// asserts they agree.
export const FREE_SHIPPING_THRESHOLD = 120;
export const FLAT_SHIPPING_RATE = 9.9;

export const FREE_SHIPPING_COPY = `Free U.S. shipping on orders over $${FREE_SHIPPING_THRESHOLD}`;
export const FREE_SHIPPING_SHORT = `Free shipping $${FREE_SHIPPING_THRESHOLD}+`;
export const FREE_SHIPPING_OVER = `On U.S. orders over $${FREE_SHIPPING_THRESHOLD}`;
export const FLAT_SHIPPING_COPY = `U.S. orders under $${FREE_SHIPPING_THRESHOLD} ship for a flat $${FLAT_SHIPPING_RATE.toFixed(2)}`;

/** The /shipping page's meta description: routes.mjs (prerendered head) and ShippingInfo.tsx (Helmet) both use it. */
export const SHIPPING_META_DESCRIPTION = `Free U.S. shipping on orders over $${FREE_SHIPPING_THRESHOLD}, flat $${FLAT_SHIPPING_RATE.toFixed(2)} below that. U.S. delivery in 4–10 business days; Canadian orders ship free over $500.`;

export const DELIVERY_WINDOW_COPY = "4–10 business days in the U.S., 4–13 in Canada (including processing)";

export const SHIPPING_REGION_COPY =
  "We deliver across the contiguous U.S. and Canada. Canadian orders ship free over $500; below that, the rate is shown at checkout. We can't ship to Alaska, Hawaii or Puerto Rico.";

/** Return eligibility, as the fulfilling store states it. */
export const RETURN_CONDITION_COPY =
  "Items must be unused, in the condition you received them, and in their original packaging — keep the box until you're sure.";

export const RETURNS_WINDOW_COPY = "30-day returns";

export const RETURN_SHIPPING_COPY =
  "Return shipping is covered by us only if the item arrives damaged, defective or incorrect. Otherwise return shipping is the customer's responsibility.";

export const FAQ_SECTIONS = [
  {
    category: "Shipping & Delivery",
    faqs: [
      { q: "How long does shipping take?", a: `Delivery takes ${DELIVERY_WINDOW_COPY}.` },
      { q: "Do you offer free shipping?", a: `${FREE_SHIPPING_COPY}. ${FLAT_SHIPPING_COPY}. ${SHIPPING_REGION_COPY}` },
      { q: "Do you deliver to Canada?", a: `Yes. ${SHIPPING_REGION_COPY} Canadian orders take 4–13 business days, including processing.` },
    ],
  },
  {
    category: "Returns",
    faqs: [
      { q: "What is your return policy?", a: `30 days from delivery. ${RETURN_CONDITION_COPY}` },
      { q: "What's the return cost?", a: `${RETURN_SHIPPING_COPY} Original shipping charges are non-refundable.` },
      { q: "Can I cancel or modify my order?", a: "Orders are placed with our fulfilment partner, FurniFindUSA, who may not be able to cancel or change an order once it has been accepted, so please check your order before paying. If you need a change, email hello@loftloom.com straight away and we'll ask them." },
    ],
  },
  {
    category: "Payments & Financing",
    faqs: [
      { q: "Do you offer financing?", a: "We don't offer financing of our own. The checkout may show a pay-over-time option (Lay-Buy); it is run by a third party under its own terms." },
      { q: "Who processes my payment?", a: "Payment is completed securely on furnifindusa.com, our order-processing site. You'll see the FurniFindUSA name on the payment page and on your bank statement — your order is still with LoftLoom." },
      { q: "What payment methods do you accept?", a: "Payment is taken on the checkout page, which lists the methods available for your order, such as PayPal. If you don't have a PayPal account, PayPal may offer to take a debit or credit card as a guest." },
    ],
  },
  {
    category: "Products & Care",
    faqs: [
      { q: "How do I care for my furniture?", a: "Care instructions vary by material. Where the supplier lists a material, we show care guidance in the Care section on the product page." },
      { q: "Do you offer trade or B2B discounts?", a: "No. Prices are set by our supply partner, so we can't offer trade or volume discounts. If you're furnishing a project, the Trade & Projects page explains how we can help you shortlist pieces." },
    ],
  },
];
